import ClientFactory, { ProduceParams } from '@/commons/utils/client.factory';
import { getToken } from '@/commons/utils/cookies';
import {
    handlerErrorMsg,
    requestInterceptor,
    responseHandlerProducer,
} from '@/commons/utils/request.interceptor';
import { AxiosRequestConfig } from 'axios';

/**
 * 登录client创建参数
 */
const baseParams: ProduceParams = {
    config: {
        // todo:
        baseURL: process.env.VUE_APP_BASE_URL,
        timeout: 10000,
    },
    requestInterceptor: requestInterceptor(),
    responseInterceptor: {
        onFulfilled: responseHandlerProducer(),
        onRejected: handlerErrorMsg,
    },
};

/**
 * 移动端员工平台client
 */
const baseClient = ClientFactory.produce(baseParams);
export default baseClient;
